import React, { useState } from 'react';

// 더미 데이터
const dummyProducts = [
    {
        id: 1,
        title: '연기 기초 마스터 클래스',
        description: '연기 초보자를 위한 완벽한 가이드',
        image: 'https://via.placeholder.com/200',
        price: 99000,
        originalPrice: 149000,
        discount: 33,
        sales: 125,
        revenue: 12375000,
        status: '판매중',
        category: '클래스',
        createdAt: '2025-01-10'
    },
    {
        id: 2,
        title: 'K-pop 댄스 비디오 강의',
        description: '인기 K-pop 댄스 동작을 단계별로 배우세요',
        image: 'https://via.placeholder.com/200',
        price: 79000,
        originalPrice: 99000,
        discount: 20,
        sales: 89,
        revenue: 7031000,
        status: '판매중',
        category: '비디오',
        createdAt: '2025-01-08'
    },
    {
        id: 3,
        title: '보컬 트레이닝 패키지',
        description: '호흡법부터 고음 발성까지 완벽 마스터',
        image: 'https://via.placeholder.com/200',
        price: 149000,
        originalPrice: 199000,
        discount: 25,
        sales: 45,
        revenue: 6705000,
        status: '판매중',
        category: '패키지',
        createdAt: '2025-01-05'
    },
    {
        id: 4,
        title: '오디션 준비 특강',
        description: '실전 오디션 대비 완벽 가이드',
        image: 'https://via.placeholder.com/200',
        price: 199000,
        originalPrice: 249000,
        discount: 20,
        sales: 0,
        revenue: 0,
        status: '판매중지',
        category: '특강',
        createdAt: '2025-01-15'
    }
];

const KoachSalesProduct = () => {
    const [products] = useState(dummyProducts);
    const [filter, setFilter] = useState('all');

    const filteredProducts = filter === 'all' 
        ? products 
        : products.filter(p => p.status === filter);

    const totalRevenue = products.reduce((sum, p) => sum + p.revenue, 0);
    const totalSales = products.reduce((sum, p) => sum + p.sales, 0);

    return (
        <div className="min-h-screen bg-gray-50 pt-20 pb-4 px-4">
            <div className="max-w-6xl mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">상품 관리</h1>
                    <button className="px-4 py-2 bg-[#CF3688] text-white rounded-lg hover:bg-[#B52E74] transition-colors">
                        새 상품 등록
                    </button>
                </div>

                {/* 통계 카드 */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <p className="text-sm text-gray-600 mb-1">총 판매액</p>
                        <p className="text-2xl font-bold text-gray-900">
                            {totalRevenue.toLocaleString()}원
                        </p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <p className="text-sm text-gray-600 mb-1">총 판매량</p>
                        <p className="text-2xl font-bold text-gray-900">
                            {totalSales.toLocaleString()}개
                        </p>
                    </div>
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <p className="text-sm text-gray-600 mb-1">등록된 상품</p>
                        <p className="text-2xl font-bold text-gray-900">
                            {products.length}개
                        </p>
                    </div>
                </div>

                <div className="flex gap-2 mb-6">
                    <button
                        onClick={() => setFilter('all')}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            filter === 'all' 
                                ? 'bg-[#CF3688] text-white' 
                                : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        전체
                    </button>
                    <button
                        onClick={() => setFilter('판매중')}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            filter === '판매중' 
                                ? 'bg-[#CF3688] text-white' 
                                : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        판매중
                    </button>
                    <button
                        onClick={() => setFilter('판매중지')}
                        className={`px-4 py-2 rounded-lg transition-colors ${
                            filter === '판매중지' 
                                ? 'bg-[#CF3688] text-white' 
                                : 'bg-white text-gray-700 hover:bg-gray-100'
                        }`}
                    >
                        판매중지
                    </button>
                </div>
                
                <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        상품 정보
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        가격
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        판매량
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        매출
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        상태
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        관리
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {filteredProducts.map((product) => (
                                    <tr key={product.id} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="flex items-center">
                                                <img 
                                                    src={product.image} 
                                                    alt={product.title}
                                                    className="w-16 h-16 rounded-lg object-cover mr-4"
                                                />
                                                <div>
                                                    <div className="text-sm font-medium text-gray-900">
                                                        {product.title}
                                                    </div>
                                                    <div className="text-sm text-gray-500">
                                                        {product.description}
                                                    </div>
                                                    <div className="text-xs text-gray-400 mt-1">
                                                        {product.category} · {product.createdAt}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <div className="text-sm text-gray-900 font-semibold">
                                                {product.price.toLocaleString()}원
                                            </div>
                                            <div className="text-xs text-gray-500 line-through">
                                                {product.originalPrice.toLocaleString()}원
                                            </div>
                                            <div className="text-xs text-[#CF3688]">
                                                {product.discount}% 할인
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {product.sales.toLocaleString()}개
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-semibold">
                                            {product.revenue.toLocaleString()}원
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap">
                                            <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                                product.status === '판매중' 
                                                    ? 'bg-green-100 text-green-800' 
                                                    : 'bg-gray-100 text-gray-800'
                                            }`}>
                                                {product.status}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                            <div className="flex gap-2">
                                                <button className="text-[#CF3688] hover:text-[#B52E74]">
                                                    수정
                                                </button>
                                                <button className="text-gray-600 hover:text-gray-900">
                                                    상세
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default KoachSalesProduct;

